import React from 'react'

interface NumberProps {
  idNumber: string
  numberTxt?: string
  customClassName?: string
}

const Number = ({ idNumber, numberTxt, customClassName }: NumberProps) => {
  return (
    <div
      id={idNumber + '-number'}
      className={`border border-darkerOrangeColor bg-midOrangeColor flex justify-center items-center font-bold text-base ${customClassName}`}>
      {numberTxt}
    </div>
  )
}

export default Number
